module.exports = __webpack_public_path__ + "static/traditional-89e6933dfd9e7445466e4eacea7b58a2.png";